import { BestBidOffer } from 'global/Securities/types/api/orderbook';

import { formatCellValue, getTextColor } from './utils';

import { OHLCCellText, OHLCTableBodyData } from './TableOHLC.styled';

interface BestBidOfferProps {
  previous: number;
  data: BestBidOffer;
}

const OHLCBestBidOffer = (props: Readonly<BestBidOfferProps>) => {
  const { data, previous } = props;

  if (!data) return null;

  return (
    <tr className="best-bid-offer">
      <OHLCTableBodyData>
        <OHLCCellText minWidth={40} maxWidth={55}>
          -
        </OHLCCellText>
      </OHLCTableBodyData>
      <OHLCTableBodyData>
        <OHLCCellText minWidth={50}>
          {formatCellValue(data.bid?.quantity?.raw)}
        </OHLCCellText>
      </OHLCTableBodyData>
      <OHLCTableBodyData>
        <OHLCCellText
          data-cy="bid-price"
          minWidth={50}
          maxWidth={55}
          color={getTextColor(data.bid?.price?.raw, previous)}
        >
          {formatCellValue(data.bid?.price?.raw)}
        </OHLCCellText>
      </OHLCTableBodyData>
      <OHLCTableBodyData>
        <OHLCCellText
          data-cy="offer-price"
          minWidth={50}
          maxWidth={55}
          color={getTextColor(data.offer?.price?.raw, previous)}
        >
          {formatCellValue(data.offer?.price?.raw)}
        </OHLCCellText>
      </OHLCTableBodyData>
      <OHLCTableBodyData>
        <OHLCCellText minWidth={50}>
          {formatCellValue(data.offer?.quantity?.raw)}
        </OHLCCellText>
      </OHLCTableBodyData>
      <OHLCTableBodyData>
        <OHLCCellText minWidth={40} maxWidth={55}>
          -
        </OHLCCellText>
      </OHLCTableBodyData>
    </tr>
  );
};

export default OHLCBestBidOffer;
